import { motion } from "framer-motion";

const services = [
  {
    n: "S/01",
    title: "Diseño de productos turísticos",
    desc: "Creación de experiencias únicas que capturan la esencia auténtica del destino, optimizando costos y maximizando ingresos por viajero.",
    bullets: [
      "Storytelling de destino",
      "Rentabilidad por experiencia",
      "Diferenciación de marca",
    ],
  },
  {
    n: "S/02",
    title: "Capacitación y mentoría estratégica",
    desc: "Formación para fortalecer a tu equipo, enseñándoles cómo aplicar estrategias innovadoras y financieras para alcanzar el éxito sostenido.",
    bullets: [
      "Talleres in-company",
      "Mentoría 1:1 para fundadores",
      "Hojas de ruta de innovación",
    ],
  },
  {
    n: "S/03",
    title: "Desarrollo de destinos sostenibles",
    desc: "Transformación de destinos con modelos de negocio sólidos que aseguren su competitividad a largo plazo y su impacto positivo en la comunidad.",
    bullets: [
      "Plan maestro de destino",
      "Modelos de gobernanza",
      "KPIs de marketing turístico",
    ],
  },
];

export default function Servicios() {
  return (
    <section
      id="servicios"
      data-testid="servicios-section"
      className="relative bg-black py-28 md:py-40 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-white/50">
              <span className="h-px w-8 bg-white/40" /> Servicios
            </div>
            <h2 className="font-display mt-6 text-4xl md:text-6xl font-black tracking-tighter uppercase leading-[0.95]">
              Innovación <br /> que <span className="text-white/30">vende</span>.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-white/70 text-base md:text-lg leading-relaxed">
              Servicios diseñados para fusionar innovación con rentabilidad,
              basados en la metodología <strong className="text-white">Póker de Ases</strong> y
              25 años transformando la industria del turismo en Iberoamérica.
            </p>
          </div>
        </div>

        <div className="flex flex-col">
          {services.map((s, i) => (
            <motion.a
              key={s.n}
              href="#contacto"
              data-testid={`servicio-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group block border-t border-white/10 last:border-b py-10 md:py-14 hover:bg-white/[0.02] transition-colors"
            >
              <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-start">
                <div className="md:col-span-2 font-mono text-xs tracking-widest text-white/40">
                  {s.n}
                </div>
                <div className="md:col-span-6">
                  <h3 className="font-display text-3xl md:text-5xl font-black tracking-tighter uppercase leading-[0.95] group-hover:text-white">
                    {s.title}
                  </h3>
                </div>
                <div className="md:col-span-4">
                  <p className="text-white/70 leading-relaxed text-sm md:text-base">
                    {s.desc}
                  </p>
                  <ul className="mt-5 space-y-2">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] text-white/60"
                      >
                        <span className="h-px w-4 bg-white/40" /> {b}
                      </li>
                    ))}
                  </ul>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/70 group-hover:text-white group-hover:translate-x-1 transition-transform">
                    Hablemos <span aria-hidden>→</span>
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
